import convertProductDialogReducer from './convertProductDialogReducer';

export default convertProductDialogReducer;